import FollowButton from '@/app/[locale]/[roomId]/components/FollowButton'
import PremiumAccessButton from '@/app/[locale]/[roomId]/components/PremiumAccessButton'
import WorldAvatar from '@/app/[locale]/[roomId]/components/WorldAvatar'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useUAContext } from '@/context/UAContext'
import { useWorldCommunityContext } from '@/context/WorldCommunityContext'
import { Link } from '@/i18n/navigation'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { useIsClient } from 'usehooks-ts'

function WorldInfoCreator() {
  const t = useTranslations()
  const { followersData } = useWorldCommunityContext()
  const { isMobileLandscape, isMobileApp } = useUAContext()
  const isClient = useIsClient()
  const { roomData, isPremiumRoom, isVoucherCheckPassed } = useCheckEnterRoomContext()

  return (
    <div
      className={cn('bg-vive-surface-normal flex flex-wrap gap-4 rounded-2xl p-3 md:px-6 md:py-4', {
        'md:p-3': isMobileLandscape,
      })}
    >
      <div
        className={cn('flex min-w-39 flex-1 items-center gap-2 md:min-w-46 md:gap-4', {
          'md:min-w-39 md:gap-4': isMobileLandscape,
        })}
      >
        <WorldAvatar />
        <div className="flex min-w-0 flex-col">
          <Link
            href={`/profile/${roomData.owner.community_user_id}`}
            className="block truncate"
            target="_blank"
          >
            <span
              className={cn('subheader-2 md:subheader-1', { 'md:subheader-2': isMobileLandscape })}
            >
              {roomData.owner.display_name}
            </span>
          </Link>
          <span className="body-2 text-vive-primary-30 flex items-center">
            {t.rich('world-info.followers', { totalFollowers: followersData?.totalItems ?? 0 })}
          </span>
        </div>
      </div>
      <div
        className={cn('flex w-auto flex-shrink-0 items-center gap-2 md:gap-4', {
          'md:gap-2': isMobileLandscape,
        })}
      >
        <FollowButton />
        {isClient && isPremiumRoom && !isMobileApp && (
          <PremiumAccessButton
            isPaid={isVoucherCheckPassed}
            page="detail"
            communityUserId={roomData.owner.community_user_id}
          />
        )}
      </div>
    </div>
  )
}
export default WorldInfoCreator
